import axiosBaseApi from '../common/lib/axiosBaseApi';
import { Wallet } from './walletsServicesTypes';
import { usePosTransferVariables } from '@/services/wallets/queries/usePostTransfer';

export const getWallets = () => {
  return axiosBaseApi.get<Wallet[]>(`/v1/wallets`);
};

export const postWallet = (address: string, primary: boolean, label: string) => {
  return axiosBaseApi.post(`/v1/wallets`, { address, label, primary });
};

export const deleteWallet = (id: string) => axiosBaseApi.delete(`/v1/wallets/${id}`);

export const postTransfer = ({
  txId,
  from,
  to,
  friendId,
  referralId,
  amount,
  isSelfTransfer,
}: usePosTransferVariables) => {
  if (!to) {
    throw new Error('"to" is required');
  }
  if (!from) {
    throw new Error('"from" is required');
  }
  return axiosBaseApi.post(`/v1/wallets/transfer`, {
    txId,
    from,
    to,
    friendId,
    referralId,
    amount,
    isSelfTransfer,
  });
};
